export default __webpack_public_path__ + "f1d5f236fea716923dc1556ab74d3557.svg";